import { trendingEvents } from '@/mocks/memes';
import SectionHeader from './SectionHeader';

export default function Trending() {
  return (
    <section id="trending" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="🔥 今日热瓜头条"
          title="热门事件表情包，一网打尽"
          desc="每一场吃瓜现场，配齐表情包、梗段子和神评论。存进群聊，你就是全场最有梗的那位。"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {trendingEvents.map((e) => (
            <article key={e.id} className="group flex flex-col overflow-hidden rounded-3xl bg-background-50 ring-1 ring-background-200">
              <div className="relative overflow-hidden">
                <img
                  src={e.memeUrl}
                  alt={e.memeAlt}
                  className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-56"
                />
                <div className="absolute inset-x-3 top-3 flex items-center justify-between">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">{e.tag}</span>
                  <span className="rounded-full bg-black/55 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur-sm">{e.hot}</span>
                </div>
                <p className="absolute bottom-3 left-3 right-3 rounded-2xl bg-background-50/90 px-4 py-2.5 text-sm font-bold text-foreground-900 backdrop-blur">
                  💬 “{e.stickerText}”
                </p>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-xl text-foreground-950">{e.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  <span className="mr-1 font-bold text-secondary-700">🎙 段子</span>
                  {e.joke}
                </p>
                <div className="mt-4 rounded-2xl bg-accent-50 p-3.5 ring-1 ring-accent-200">
                  <p className="text-sm leading-relaxed text-accent-900">
                    <span className="mr-1 font-bold">👏 神评论</span> {e.comment}
                  </p>
                </div>
                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
                  <a href="#gallery" className="inline-flex items-center gap-1 font-semibold text-primary-600 hover:text-primary-700">
                    查看本瓜全部表情包 <i className="ri-arrow-right-line"></i>
                  </a>
                  <span className="inline-flex items-center gap-1"><i className="ri-chat-smile-3-line"></i>{e.comments}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}